"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPublicSettings = getPublicSettings;
exports.getPublicSettingsLoadingStatus = getPublicSettingsLoadingStatus;
function getPublicSettings(state) {
    if (state.editableSettings.publicSettings.data) {
        return state.editableSettings.publicSettings.data;
    }
    else {
        throw new Error('Public editable settings data is not available.');
    }
}
function getPublicSettingsLoadingStatus(state) {
    return state.editableSettings.publicSettings.status;
}
